<template lang="pug">
  .main(v-if="content")
    section.main__section-1(v-if="content.section1")
      .main__section-1-top
        .main__section-1-leftBlock(v-if="content.section1.img", :style="`background-image: url(${content.section1.img});`")
        .main__section-1-rightBlock
          .main__section-1-mainTitle(v-if="content.section1.title")
            | {{content.section1.title}}
          .main__section-1-additionalTitle(v-if="content.section1.subtitle")
            | {{content.section1.subtitle}}
          .main__section-1-description(v-if="content.section1.text")
            | {{content.section1.text}}
          router-link.main__section-1-btn(v-if="content.section1.btn", :to="content.section1.btn.link")
            | {{content.section1.btn.title}}
      .main__section-1-seeMore(v-if="content.section1.btnNext")
        .main__section-1-seeMore-title
          | {{content.section1.btnNext}}
        button.main__section-1-seeMore-btn
          SvgIcon.main__section-1-seeMore-btn-ico(name="arrow1", width="16", height="16")
          SvgIcon.main__section-1-seeMore-btn-ico(name="arrow1", width="22", height="12")
    section.main__section-2(v-if="content.section2")
      .main__section-2-leftBlock
        .main__section-2-background
        .page__wr
          .main__section-2-textBlock
            .main__section-2-title(v-if="content.section2.title")
              | {{content.section2.title}}
            .main__section-2-description(v-if="content.section2.text")
              | {{content.section2.text}}
            router-link.main__section-2-btn(v-if="content.section2.btn", :to="content.section2.btn.link")
              | {{content.section2.btn.title}}
      .main__section-2-rightBlock(v-if="content.section2.img", :style="`background-image: url(${content.section2.img});`")
    section.main__section-3(v-if="content.section3")
      .page__wr
        .main__section-3-title(v-if="content.section3.title")
          | {{content.section3.title}}
        .main__section-3-slider(v-if="content.section3.nav")
          .swiper-container
            .swiper-wrapper
              .swiper-slide(v-for="item in content.section3.nav", :key="item.id")
                .main__section-3-slide-item(@click="getMenuItems(item.id, $event)")
                  | {{item.title}}
          .main__section-3-slider-buttons
            button.swiper-button-prev.main__section-3-slider-prev
              SvgIcon.main__section-3-slider-prev-ico(name="arrow1", width="21", height="21")
            button.swiper-button-next.main__section-3-slider-next
              SvgIcon.main__section-3-slider-next-ico(name="arrow1", width="21", height="21")
        .main__section-3-items-wr
          PreloaderImage
          .main__section-3-items(v-if="content.section3.items && content.section3.items.length > 0")
            .main__section-3-item(v-for="item in content.section3.items", :key="item.id")
              CardProduct(:cardProduct="item")
          .main__section-3-no-items(v-else) В данной категории блюд нет
          router-link.main__section-3-btnMore(v-if="content.section3.btn", :to="content.section3.btn.link")
            | {{content.section3.btn.title}}
        .main__section-3-left-img(v-if="content.section3.imgLeft", :style="`background-image: url(${content.section3.imgLeft});`")
        .main__section-3-right-img(v-if="content.section3.imgRight", :style="`background-image: url(${content.section3.imgRight});`")
</template>

<script>
  import EventBus from '@/eventBus';

  import '@/components/main/main.styl';

  import SvgIcon from '@/components/common/svgIcon/SvgIcon.vue';
  import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';
  import {SliderHelpersVue} from '@/mixins/SliderHelpersVue';
  import CardProduct from '@/components/common/cardProduct/cardProduct.vue';
  import PreloaderImage from '@/components/common/preloaderImage/preloaderImage.vue';

  export default {
    name: 'Main',

    mixins: [AjaxHelpersVue, SliderHelpersVue],

    data() {
      return {
        content: null
      }
    },

    components: {
      SvgIcon,
      CardProduct,
      PreloaderImage
    },

    created() {
      // Загрузка данных для страницы
      EventBus.$on('loadMainPage', params => {
        this.request(params.url);
      });

      this.$nextTick(() => {
        this.initScripts();
      });
    },

    methods: {
      request(url) {
        this.req('MainPage:getMainPage', {url}, res => {
          if(this.checkProperty(res.content)) {
            this.content = res.content;

            this.$nextTick(() => {
              this.initSlider('.main__section-3-slider', {
                slidesPerView: 'auto',
                spaceBetween: 56,
                loop: false,
                breakpoints: {
                  1200: {
                    spaceBetween: 16,
                  }
                }
              });

              $('.main__section-3-slide-item').eq(0).addClass('main__section-3-slide-item--active');
            })
          }
        }, 'main');
      },

      initScripts() {
        $(document).on('click', '.main__section-1-seeMore', function() {
          $('html, body').stop().animate({
            scrollTop: $('.main__section-2').offset().top - 65
          }, 1500);
        });
      },

      getMenuItems(categoryId, e) {
        $('.main__section-3-slide-item--active').removeClass('main__section-3-slide-item--active');
        $(e.target).addClass('main__section-3-slide-item--active');

        let params = {
          categoryId: categoryId
        };

        EventBus.$emit('preloaderShow', 'main');

        this.req('MainPage:getMainMenuItems', {...params}, res => {
          if(this.checkProperty(res.items) && res.status == 'ok') {
            this.content.section3.items = res.items;

            this.$nextTick(() => {
              $('.page__items').css('height', $('.page__item--active').outerHeight(true) + 'px');

              EventBus.$emit('preloaderHide', 'main');
            })
          }
        }, '', 'localPageRequest');
      },
    }

  }
</script>
